import type { HTMLProps, MouseEvent } from 'react';

import { isExternalLink } from './isExternalLink';
import { redirectLink } from './redirectLink';

type PartialAnchorProperties = Pick<HTMLProps<HTMLAnchorElement>, 'href' | 'target' | 'rel' | 'onClick'>;

export function formatLinkProperties(link: string, isDesktop = true, callback?: () => void): PartialAnchorProperties {
  const isExternal = isExternalLink(link);
  const href = isExternal || isMailtoLink(link) ? link : cleanLink(`/${link}`);
  return {
    href,
    ...(isDesktop
      ? {}
      : {
          onClick: (e: MouseEvent<HTMLAnchorElement>) => redirectLink(e, href, callback),
        }),
    ...(isExternal ? { target: '_blank', rel: 'noopener' } : {}),
  };
}

function cleanLink(link: string): string {
  return link.replace(/\/\//, '/');
}

function isMailtoLink(link: string): boolean {
  return link.indexOf('mailto:') > -1;
}
